(function(){
  var LOGIN_URL = '/pages/login';

  function getToken(){
    try { return sessionStorage.getItem('loyaltyToken') || ''; } catch(e){ return ''; }
  }

  function isJwtExpired(token){
    try {
      var parts = token.split('.');
      if (parts.length !== 3) return false; 
      var payload = JSON.parse(atob(parts[1].replace(/-/g,'+').replace(/_/g,'/')));
      if (!payload.exp) return false;
      return Date.now() >= payload.exp * 1000;
    } catch(e){ return false; }
  }

  function clearAuth(){
    var keys = ['loyaltyToken','loyaltyTokenExpiresIn','loyaltyLoginOK','loyaltyPhone'];
    for (var i=0;i<keys.length;i++){ try { sessionStorage.removeItem(keys[i]); } catch(_){} }
  }

  function redirectToLogin(){
    var next = encodeURIComponent(location.pathname + location.search + location.hash);
    location.replace(LOGIN_URL + '?next=' + next);
  }

  function guard(){
    var t = getToken();
    if (!t || isJwtExpired(t)){
      clearAuth();
      redirectToLogin();
    }
  }

  function bindLogout(){
    function doLogout(e){
      if (e) e.preventDefault();
      clearAuth();
      redirectToLogin();
     sessionStorage.setItem("timout_logout", "manual");

    }

    try { window.npLogout = doLogout; } catch(_){}

    var byId = document.getElementById('btn-logout');
    if (byId){ byId.addEventListener('click', doLogout); return; }

    var links = document.querySelectorAll('a,button');
    outer: for (var i=0;i<links.length;i++){
      var el = links[i];
      var txt = (el.textContent || '').trim().toLowerCase();
      if (/log\s*out|logout/.test(txt)){
        el.addEventListener('click', doLogout);
        break;
      }
      var icons = el.querySelectorAll('i.material-icons-outlined');
      for (var j=0;j<icons.length;j++){
        if ((icons[j].textContent || '').trim() == 'power_settings_new'){
          el.addEventListener('click', doLogout);
          break outer;
        }
      }
    }
  }

  guard();

  window.addEventListener('storage', function(e){
    if (e.key === 'loyaltyToken' && !e.newValue) guard();
  });

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bindLogout);
  } else {
    bindLogout();
  }

  
  

})();
